<template>
  <v-app-bar app clipped-left color="white">
    <v-img :src="require('@/assets/logo_dark.png')" contain class="mt-2" width="150px" height="55px"></v-img>

    <v-tabs centered>
      <v-tab>
        {{ $t('Menu.Topbar.home') }}
      </v-tab>
      <v-tab disabled>
        {{ $t('Menu.Topbar.faq') }}
      </v-tab>
    </v-tabs>

    <v-spacer></v-spacer>

    <v-btn icon @click="setShowLanguages(true)" color="primary">
      <v-icon>language</v-icon>
    </v-btn>

    <v-btn rounded light color="primary" class="ml-3" @click="goToMySpace">
      {{ $t('Menu.Topbar.myspace') }}
    </v-btn>

  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { ROUTE_MY } from '@/router/index'

export default {
  name: 'TheTopBar',
  computed: {
    ...mapState('auth', [
      'isLogged',
    ]),
  },
  methods: {
    ...mapMutations('auth', [
      'setShowLoginManager'
    ]),
    ...mapMutations('lang', [
      'setShowLanguages'
    ]),
    goToMySpace () {
      if (this.isLogged) {
        this.$router.push({ name: ROUTE_MY })
      } else {
        this.setShowLoginManager(true)
      }
    },
  }
}
</script>
